import axios from 'axios';
import { after } from './interceptors';
import { get } from '../../utils/data';
import { TypeRequest } from '../../types';
import adapterInit from './adapter';

function createFetch(): TypeRequest {
  const initProps = get('initProps') || {};
  const { host, isBoe = false } = initProps;
  const xhr = axios.create({
    baseURL:
      host ||
      (window && `${isBoe ? 'http' : 'https'}://${window.location.hostname}`),
    adapter: adapterInit(),
    withCredentials: true,
    transformRequest: [
      data => {
        let dataObj = data;
        if (typeof data === 'string') {
          try {
            dataObj = JSON.parse(data);
          } catch (error) {
            console.log(error);
          }
        }
        return dataObj;
      },
    ],
  });

  xhr.interceptors.response.use(after as any, undefined);
  return xhr;
}

export default createFetch;
